import { createAction } from "redux-actions";

import { SET_LOYALTY_IS_OPTED_IN } from "../constants";

const setLoyaltyIsOptedIn = createAction(SET_LOYALTY_IS_OPTED_IN);

export default setLoyaltyIsOptedIn;
